module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-measure",
      "title": _vm.title
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36818e2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/Measure.vue
// module id = 844
// module chunks = 39